<template>
    <v-container fluid class="px-0 py-0">
        <v-expand-transition>
            <crud :cfg="stuCrudCfg" v-show="stuCrudShow"></crud>
        </v-expand-transition>
        <div class="acts" v-if="logCrudCfg"><span @click="stuCrudShow = !stuCrudShow"><v-icon>{{ stuCrudShow ?
            'arrow_drop_up' :
            'arrow_drop_down' }}</v-icon></span></div>
        <v-expand-transition>
            <v-card v-if="logCrudCfg">
                <v-card-text>
                    <crud :timestamp="logTs" :cfg="logCrudCfg"></crud>
                </v-card-text>
            </v-card>
        </v-expand-transition>
    </v-container>
</template>
<script>
import { Crud } from "javaee-fre";
export default {
    name: "refund-parse",
    components: {
        Crud,
    },
    data() {
        let self = this;
        return {
            stuCrudCfg: {
                url: '/home/admin/sys/refund/stu',
                desc: '<p class="sys-info">请先检索需要退费学员，确认学员之后点击后面<b>操作退课/退费</b>按钮</p>',
                listItemActions: [
                    {
                        label: '开课记录', icon: 'menu', func(cfg) {
                            let acc = cfg.item;
                            self.logCrudCfg = {
                                url: '/home/admin/sys/refund/stu/clazz', params: { _aid: cfg.item.id },
                                desc: `<p class="sys-info">以下为<b>${acc.name}</b>的开课记录<small> - 请点击需要退课记录后面的退课退费按钮执行退费操作</small></p>`,
                                listItemActions: [{
                                    label: '操作退课/退费',
                                    icon: 'arrow_back',
                                    func(cfg2) {
                                        let self = this;
                                        self.$dialog.crud(`填写退费说明 - ${cfg2.item.clazzName}`, {
                                            width: 800,
                                            forceEditFormStretch: true,
                                            url: '/home/admin/sys/refund/log',
                                            initPanel: 'edit',
                                            createable: true,
                                            params: { _scId: cfg2.item.id },
                                            onSaveSuccess() {
                                                self.refresh();
                                                self.$dialog.close();
                                            }
                                        });
                                    }
                                }],
                                listItemFilter(i, acts) {
                                    if (this.$dictVal(i.status) == 0) {
                                        this.delAction(acts, 'icon', 'arrow_back');
                                    }
                                    return acts;
                                }
                            };
                            self.logTs = Date.now();
                            self.stuCrudShow = false;
                        }
                    }
                ]
            },
            logCrudCfg: null,
            logTs: Date.now(),
            stuCrudShow: true
        }
    }
}
</script>
<style scoped>
.acts {
    text-align: center;
}

.acts span {
    display: inline-block;
    width: 100px;
    background-color: #ccc;
    cursor: pointer;
}
</style>